import { Outlet } from "react-router-dom";
import TopHeader from "../components/TopHeader";
import MainNavbar from "../components/MainNavbar";
import Footer from "../components/Footer";

function MainLayout() {
  return (
    <>
      <TopHeader />

      <MainNavbar />

      <Outlet />

      <Footer />
    </>
  );
}

export default MainLayout;